import { Vertragsoptionen } from '@ps20-frontend/frontend-models';
import { VhvAction } from '../vhvActions';

export interface VertragsoptionenVHV extends Vertragsoptionen {
  versicherungssummeArt: string;
  versicherungssumme: number;
}

export enum VersicherungssummeEnum {
  EMPFOHLEN_VERSSUMME = 'die empfohlene',
  INDV_VERSSUMME = 'eine individuelle',
  BISHERIGE_VERSSUMME = 'die bisherige',
}

interface WohnflaecheChangedPayload {
  wohnflaeche: number;
}

interface VersicherungssummeChangedPayload {
  versicherungssumme: number;
}

interface VersicherungssummenArtChangedPayload {
  verssummeArt: VersicherungssummeEnum;
}

export type WohnflaecheChangedAction = VhvAction<WohnflaecheChangedPayload>;
export type VersicherungssummeChangedAction = VhvAction<VersicherungssummeChangedPayload>;
export type VersicherungssummenArtChangedAction = VhvAction<VersicherungssummenArtChangedPayload>;
